import $ from 'jquery';
import _ from 'underscore';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectThank',
			dom: {
				message: '#yotaConnectThankMessage',
				template: '#yotaConnectThankTemplate'
			},
			data: {
				type: '',
				login: ''
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.sended = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$message = this.$el.find(this.options.dom.message);
		this.$template = this.$el.find(this.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		return this;
	}

	update(data) {
		if (typeof data !== 'undefined') {
			this.data = data;
		}

		const html = this.template(this.data);
		this.$message.html(html);

		return self;
	}


	render() {
		if (this.$el.length) {
			this
				.getDom()
				.update();

		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/thank/thank.js